// extracted by mini-css-extract-plugin
export default {"mCard":"Uv-z","image":"Vv-z","imageNoBackground":"Wv-z","imageHasCategory":"Xv-z","fullWidth":"Yv-z"};